/**
 * Re-export the auth store so existing imports of `useAuth` keep working.
 * The actual logic lives in src/store/auth.ts.
 */

import { useAuthStore } from '../store/auth';

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const loading = useAuthStore((s) => s.loading);
  const signOut = useAuthStore((s) => s.signOut);
  return { user, loading, signOut };
}

export { useAuthStore };
